import React from 'react';

import Welcome from '../../../../components/Welcome/Welcome';

import styles from './Search.scss';
import SearchBar from './components/SearchBar/SearchBar';

interface Props {
  showTitle?: boolean;
}

const Search: React.FC<Props> = ({ showTitle }) => (
  <section className={showTitle ? styles.homeContainer : styles.container}>
    <div className={styles.inner}>
      {showTitle && (
        <div className={styles.searchHeader}>
          <Welcome />
        </div>
      )}
      <SearchBar />
    </div>
  </section>
);

export default Search;
